var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingResource } from "../../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../../constants/IdResource";
import { selectActiveBuildingCostBuff } from "../../../../selectors/selectBuffsInfo";
import { utilBuff } from "../../../../utils/utilBuff";
import { ButtonDefault } from "../../../generic/button-buy/ButtonDefault";
import { ButtonPrimary } from "../../../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../../../generic/common/ButtonSecondary";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TypeNumberRounding } from "../../../generic/round-format/TypeNumberRounding";
var ButtonUpgradeBuildingDOM = /** @class */ (function (_super) {
    __extends(ButtonUpgradeBuildingDOM, _super);
    function ButtonUpgradeBuildingDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPremiumBuilding = function () {
            var _a = _this.props, building = _a.building, onUpgradeGold = _a.onUpgradeGold, stage = _a.stage, premiumCostBuff = _a.premiumCostBuff;
            if (stage.standard && building && stage.standard.cost.length > 1) {
                return undefined;
            }
            if (stage.premium && building) {
                var cost = stage.premium.cost[0];
                var shownStat = selectBalancingResource(cost.resourceId).shownStat;
                var icon = shownStat && shownStat.length > 0 ? shownStat[0].icon : IdIcon.GoldIcn;
                var amount = cost.amount;
                var buffedAmount = premiumCostBuff
                    ? utilBuff.applyTo(amount, premiumCostBuff, TypeNumberRounding.Ceil)
                    : undefined;
                return (React.createElement(ButtonDefault, { onClick: function () { return onUpgradeGold(building); }, component: ButtonSecondary, amount: amount, buffedAmount: buffedAmount, icon: icon }));
            }
            return undefined;
        };
        _this.getStandardBuilding = function () {
            var _a = _this.props, building = _a.building, onUpgradeResources = _a.onUpgradeResources, stage = _a.stage;
            if (stage.standard && building) {
                var cost = stage.standard.cost[0];
                var shownStat = selectBalancingResource(cost.resourceId).shownStat;
                var icon = shownStat && shownStat.length > 0 ? shownStat[0].icon : IdIcon.FarmDollarsIcn;
                return (React.createElement(ButtonDefault, { onClick: function () { return onUpgradeResources(building); }, component: ButtonPrimary, amount: cost.amount, icon: icon }));
            }
            return undefined;
        };
        return _this;
    }
    ButtonUpgradeBuildingDOM.prototype.render = function () {
        var premiumBuildingButton = this.getPremiumBuilding();
        var standardBuildingButton = this.getStandardBuilding();
        return (React.createElement("div", { className: "building-upgrade__buttons" },
            premiumBuildingButton,
            standardBuildingButton));
    };
    return ButtonUpgradeBuildingDOM;
}(React.Component));
var mapState = function (state, ownProps) { return ({
    premiumCostBuff: selectActiveBuildingCostBuff(state, ownProps.building.balancing.id, IdResource.Gold),
}); };
export var ButtonUpgradeBuilding = connect(mapState)(ButtonUpgradeBuildingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/ButtonUpgradeBuilding.tsx
// module id = 2864
// module chunks = 3